module.exports = __webpack_public_path__ + "img/2.f2b71135.png";